module.exports = __webpack_public_path__ + "img/2.49628a1b.png";